function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import Popover2 from "./popover-2";
import Layout from "../layout/layout";
import Bar from "../layout/bar";
import FilterPopoverDropdown from "./filter-popover-dropdown";
import FilterPopoverRadio from "./filter-popover-radio";
import Button from "../elements/button";
import ButtonTooltip from "./button-tooltip";
import Checkbox from "../forms/checkbox";
import Icon from "../elements/icon";

var FilterPopover = function FilterPopover(_ref) {
  var className = _ref.className,
      buttonClassName = _ref.buttonClassName,
      config = _ref.config,
      activeFilters = _ref.activeFilters,
      onFilterChange = _ref.onFilterChange,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "More Filters" : _ref$buttonText,
      _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? "toggle" : _ref$buttonType,
      _ref$showCount = _ref.showCount,
      showCount = _ref$showCount === void 0 ? true : _ref$showCount,
      _ref$onApply = _ref.onApply,
      onApply = _ref$onApply === void 0 ? _.noop : _ref$onApply,
      onClear = _ref.onClear,
      _ref$onOpen = _ref.onOpen,
      onOpen = _ref$onOpen === void 0 ? _.noop : _ref$onOpen,
      _ref$onClose = _ref.onClose,
      _onClose = _ref$onClose === void 0 ? _.noop : _ref$onClose,
      placement = _ref.placement;

  var onTempCheckboxFilterChange = function onTempCheckboxFilterChange(isChecked, filterKey, section) {
    var oldSection = activeFilters[section] || [];
    var newSection = isChecked ? oldSection.concat(filterKey) : _.without(oldSection, filterKey);

    var newFilters = _objectSpread(_objectSpread({}, activeFilters), {}, _defineProperty({}, section, newSection));

    onFilterChange(newFilters);
  };

  var onTempDropdownFilterChange = function onTempDropdownFilterChange(section, options) {
    var newFilters = _objectSpread(_objectSpread({}, activeFilters), {}, _defineProperty({}, section, options));

    onFilterChange(newFilters);
  };

  var onTempRadioFilterChange = function onTempRadioFilterChange(section, value) {
    var newFilters = _objectSpread(_objectSpread({}, activeFilters), {}, _defineProperty({}, section, value));

    onFilterChange(newFilters);
  }; // Used for calculating the total number of applied filters
  // multi-select options come in as an array but single select (radio)
  // Comes in as a value, in those cases, just increment the total by one


  var numFilters = _.reduce(activeFilters, function (memo, item) {
    var total = 0;

    if (Array.isArray(item)) {
      total = item.length;
    } else {
      total = 1;
    }

    return memo + total;
  }, 0);

  return /*#__PURE__*/React.createElement(Popover2, {
    className: className,
    placement: placement,
    onClose: function onClose() {
      onApply();

      _onClose();
    },
    trigger: function trigger(_ref2) {
      var togglePopover = _ref2.togglePopover,
          is_open = _ref2.is_open;
      return /*#__PURE__*/React.createElement(Button, {
        type: buttonType,
        className: buttonClassName,
        onClick: function onClick() {
          // if not open yet, then it will be opened
          if (!is_open) {
            onOpen();
          }

          togglePopover();
        }
      }, _.isFunction(buttonText) ? buttonText(numFilters, is_open) : /*#__PURE__*/React.createElement("span", null, buttonText, numFilters && showCount ? " (".concat(numFilters, ")") : ""));
    }
  }, function (_ref3) {
    var closePopover = _ref3.closePopover;
    return /*#__PURE__*/React.createElement(Layout, {
      footerBorder: false,
      footer: /*#__PURE__*/React.createElement(Bar, {
        padding: "20px 30px",
        right: /*#__PURE__*/React.createElement("div", null, _.isFunction(onClear) ? /*#__PURE__*/React.createElement(Button, {
          type: "simple",
          onClick: function onClick() {
            closePopover();
            onClear();
          }
        }, "Clear") : null, /*#__PURE__*/React.createElement(Button, {
          className: "et--filter-apply",
          onClick: function onClick() {
            closePopover();
            onApply();
          }
        }, "Apply"))
      })
    }, _.map(config, function (values, section) {
      return /*#__PURE__*/React.createElement("div", {
        className: "et--filter-section",
        key: values.title
      }, /*#__PURE__*/React.createElement("div", {
        className: "et--filter-group-name"
      }, /*#__PURE__*/React.createElement("div", {
        className: "et--filter-group-name-title"
      }, /*#__PURE__*/React.createElement("strong", null, values.title), /*#__PURE__*/React.createElement("span", {
        className: "et--filter-group-help"
      }, values.help_tip ? /*#__PURE__*/React.createElement(ButtonTooltip, {
        trigger: /*#__PURE__*/React.createElement(Icon, {
          icon: "help",
          style: {
            color: "#aec6cc"
          }
        })
      }, values.help_tip) : null))), /*#__PURE__*/React.createElement("div", {
        className: "et--filter-group-options"
      }, (!values.type || values.type === "checkbox") && _.map(values.options, function (_ref4) {
        var name = _ref4.name,
            key = _ref4.key,
            icon = _ref4.icon,
            color = _ref4.color;
        var sectionKeys = activeFilters[section] || [];
        return /*#__PURE__*/React.createElement("div", {
          className: "et--filter-option",
          key: key
        }, name !== "spacer" ? /*#__PURE__*/React.createElement(Checkbox, {
          checked: _.contains(sectionKeys, key),
          onChange: function onChange(isChecked) {
            return onTempCheckboxFilterChange(isChecked, key, section);
          },
          label: name
        }, name, icon ? /*#__PURE__*/React.createElement(Icon, {
          icon: icon,
          className: "et--filter-option-icon",
          style: {
            color: color
          }
        }) : null) : null);
      }), values.type === "dropdown" && /*#__PURE__*/React.createElement(FilterPopoverDropdown, {
        filterKey: section,
        options: values.options,
        values: activeFilters[section],
        onChange: onTempDropdownFilterChange,
        onSearch: values.onSearch,
        multiple: values.multiple,
        searchable: values.searchable,
        allowChangeAll: values.allowChangeAll,
        allowUnselectAll: values.allowUnselectAll,
        width: values.width
      }), values.type === "radio" && /*#__PURE__*/React.createElement(FilterPopoverRadio, {
        filterKey: section,
        options: values.options,
        onChange: onTempRadioFilterChange,
        value: activeFilters[section] || values.default
      })));
    }));
  });
};

FilterPopover.propTypes = {
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  placement: PropTypes.string,
  config: PropTypes.object,
  activeFilters: PropTypes.object,
  onFilterChange: PropTypes.func,
  buttonText: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  buttonType: PropTypes.string,
  showCount: PropTypes.bool,
  onApply: PropTypes.func,
  onClear: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
export default FilterPopover;